import {
  Button,
  Card,
  EButtonColorVariant,
  EHeadingStyleVariant,
  ETagVariant,
  Heading,
  Tag,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';

import useWindowSize from '@/hooks/useWindowSize';

type TClaimsGuideCarouselSlideProps = {
  imageSrc: string;
  linkText: string;
  linkHref: string;
  number: string;
  title: React.ReactNode;
  description: React.ReactNode;
};

export const ClaimsGuideCarouselSlide = ({
  imageSrc,
  linkText,
  linkHref,
  number,
  title,
  description,
}: TClaimsGuideCarouselSlideProps) => {
  const windowSize = useWindowSize();

  return (
    <Card withBoxShadow={false}>
      <div
        style={{ height: `calc(${windowSize.height || 0}px - 5vh)` }}
        className="flex flex-col overflow-hidden md:!h-[800px] md:max-h-[80vh]">
        <Card.Media image={imageSrc} className="overflow-hidden grow">
          <Button
            label={linkText}
            href={linkHref}
            variant={EButtonColorVariant.Tertiary}
            onDark={true}
            target="_blank"
            tabIndex={-1}
            className="absolute bottom-4 right-4"
          />
        </Card.Media>

        <Card.Content className="p-6 h-[250px] md:h-[200px] shrink-0">
          <Tag variant={ETagVariant.Green} label={number} className="mb-2 [&>*]:!text-sm" />
          <Heading variant={EHeadingStyleVariant.H5}>{title}</Heading>
          <Text className="mt-2">{description}</Text>
        </Card.Content>
      </div>
    </Card>
  );
};
